/**
 * Lightweight synchronous role helper.
 *
 * NOTE (QA shim — iteration 48): pages DataFreshness.jsx / ConnectedServices.jsx
 * import `hasRole` from "@/lib/auth", but that module did not exist which broke
 * the whole webpack build. This module provides the missing helper. The cache is
 * kept in sync by AuthContext (see `setAuthUser`) and mirrored into localStorage
 * so a hard refresh still resolves the role on first render.
 * The main agent should consider migrating these pages to `useAuth()` instead.
 */
const STORAGE_KEY = "vault_user_role";

let cachedUser = null;

export function setAuthUser(user) {
    cachedUser = user && typeof user === "object" ? user : null;
    try {
        if (cachedUser?.role) localStorage.setItem(STORAGE_KEY, cachedUser.role);
        else localStorage.removeItem(STORAGE_KEY);
    } catch { /* noop */ }
}

export function getAuthUser() {
    return cachedUser;
}

export function currentRole() {
    if (cachedUser?.role) return cachedUser.role;
    try { return localStorage.getItem(STORAGE_KEY) || null; } catch { return null; }
}

export function hasRole(...roles) {
    const role = currentRole();
    if (!role) return false;
    return roles.flat().filter(Boolean).includes(role);
}

export default hasRole;
